var hotels = [
  {  "placeId":"1",
     "id":"1",
     "image":"https://i.ibb.co/6YY9tFP/Rectangle-26.png",
     "name":"Light bright airy stylish apt & safe peaceful stay",
     "guestNo":4,
     "bedrooms":2,
     "beds":2,
     "baths":2,
     "facilities":"Wif Air conditioning Kitchen Cancellation fexibility availiable",
     "rating":4.9,
     "price":34,
     "totalPrice":167
  },
  { "placeId":"1",
    "id":"2",
    "image":"https://i.ibb.co/HVJPKQK/Rectangle-27.png",
    "name":"Apartment in Lost Panorama",
    "guestNo":4,
    "bedrooms":2,
    "beds":2,
    "baths":2,
    "facilities":"Wif Air conditioning Kitchen Cancellation fexibility availiable",
    "rating":4.9,
    "price":34,
    "totalPrice":167
  },
  { "placeId":"1",
    "id":"3",
    "image":"https://i.ibb.co/MB8J1qm/Rectangle-28.png",
    "name":"AR Lounge & Pool (r&r + b&b)",
    "guestNo":4,
    "bedrooms":2,
    "beds":2,
    "baths":2,
    "facilities":"Wif Air conditioning Kitchen Cancellation fexibility availiable",
    "rating":4.9,
    "price":34,
    "totalPrice":167
  },
  { "placeId":"2",
    "id":"2",
    "image":"https://i.ibb.co/HVJPKQK/Rectangle-27.png",
    "name":"Apartment in Lost Panorama",
    "guestNo":4,
    "bedrooms":2,
    "beds":2,
    "baths":2,
    "facilities":"Wif Air conditioning Kitchen Cancellation fexibility availiable",
    "rating":4.9,
    "price":34,
    "totalPrice":167
  },
  { "placeId":"2",
    "id":"3",
    "image":"https://i.ibb.co/MB8J1qm/Rectangle-28.png",
    "name":"AR Lounge & Pool (r&r + b&b)",
    "guestNo":4,
    "bedrooms":2,
    "beds":2,
    "baths":2,
    "facilities":"Wif Air conditioning Kitchen Cancellation fexibility availiable",
    "rating":4.9,
    "price":34,
    "totalPrice":167
  },
  {  "placeId":"3",
    "id":"1",
    "image":"https://i.ibb.co/6YY9tFP/Rectangle-26.png",
    "name":"Light bright airy stylish apt & safe peaceful stay",
    "guestNo":4,
    "bedrooms":2,
    "beds":2,
    "baths":2,
    "facilities":"Wif Air conditioning Kitchen Cancellation fexibility availiable",
    "rating":4.9,
    "price":34,
    "totalPrice":167
},
{ "placeId":"3",
  "id":"3",
  "image":"https://i.ibb.co/MB8J1qm/Rectangle-28.png",
  "name":"AR Lounge & Pool (r&r + b&b)",
  "guestNo":4,
  "bedrooms":2,
  "beds":2,
  "baths":2,
  "facilities":"Wif Air conditioning Kitchen Cancellation fexibility availiable",
  "rating":4.9,
  "price":34,
  "totalPrice":167
  },
  { "placeId":"3",
    "id":"2",
    "image":"https://i.ibb.co/HVJPKQK/Rectangle-27.png",
    "name":"Apartment in Lost Panorama",
    "guestNo":4,
    "bedrooms":2,
    "beds":2,
    "baths":2,
    "facilities":"Wif Air conditioning Kitchen Cancellation fexibility availiable",
    "rating":4.9,
    "price":34,
    "totalPrice":167
  }

];

export default hotels;